'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _urlSearchParams = require('@ungap/url-search-params');

var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function handleChange(_ref, els, searchParams) {
  var target = _ref.target;

  searchParams.set('sort_by', target.value);
  window.location.search = searchParams.toString();
}

function init(_ref2) {
  var el = _ref2.el,
      context = _ref2.context;

  var els = {
    el: el,
    select: context.getElement('.' + context.className + '_Select')
  };
  var searchParams = new _urlSearchParams2.default(window.location.search);

  var changeEvent = function changeEvent(event) {
    return handleChange(event, els, searchParams);
  };

  els.select.addEventListener('change', changeEvent);
}